export enum LengthUnit {
  Cm,
  Inch,
}
